<form [formGroup]="service24Form" class="service24-form"
    [class.full-text]="showFullText()">
    <div class="flex">
        <form-checkbox [inputControl]="acceptService24PolicyControl"
            data-testid="service24-agreement-checkbox"
            [disabled]="settingsAccount.service24PolicyAccepted() === true">
        </form-checkbox>
        <p class="agreement" data-testid="service24-agreement">{{subtitle(8249)}}</p>
        <img [class.rotate]="showFullText()" ngSrc="/assets/img/icons/black-arrow.svg"
             data-testid="agreement-menu-icon"
             priority="true"
             (click)="toggleText()"
             width="24" height="24" alt="" />
    </div>
    @if(settingsAccount.service24PolicyAccepted() !== true) {
        <div class="btn-row">
            <form-button [subtitle]="subtitle(1255)"
                         [btnType]="'confirm'"
                         (click)="saveAgreement()">
            </form-button>
        </div>
    }
</form>
